var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/benefits-series-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <button class=\"modal__print-btn btn\" data-js-ui=\"print-modal\">\n        <span class=\"modal__print-btn-label\" data-auto-translate=\"true\">Print</span>\n        <span class=\"modal__print-btn-icon icon-print\"></span>\n    </button>\n    <div class=\"modal__text-container\">\n        <h1 class=\"modal__title style--underlined\" data-auto-translate=\"true\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n        </h1>\n\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "jsList");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            <span class=\"modal__list-title\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "</span>\n            <ul class=\"modal__list\">\n                ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"list");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("listItem", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                    <li class=\"modal__list-item\" data-auto-translate=\"true\">";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "</li>\n                ";
;
}
}
frame = frame.pop();
output += "\n            </ul>\n        ";
;
}
}
frame = frame.pop();
output += "\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/benefits-series-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/benefits-series-view.njk
// module id = 474
// module chunks = 0